import { type FC, useEffect } from "react";
import { Button } from "@wbly/ui";
import type { ImageField } from "@prismicio/client";
import style from "./Hero.module.css";
import wrapperStyle from "./ContentWrapper.module.css";
import "../../style/Themes.module.css";
import { trackHeroCta, trackHeroLoad } from "./track-hero-events";

const { slide, content, image: imageSt, buttonSt } = style;
const { contentWrapper } = wrapperStyle;

type SlideProps = {
  title: string;
  description: string;
  placeholder?: boolean;
  children?: React.ReactNode;
  image: {
    desktop: ImageField | null;
    mobile: ImageField | null;
  };
  theme: string;
  cutout?: string;
  ctaLabel?: string;
  url?: string;
  index?: number;
};

const handleClick = (url: string, index: number) => {
  trackHeroCta(url, index);
  window.location.href = url;
};

export const Slide: FC<SlideProps> = (props) => {
  const {
    children,
    title,
    description,
    placeholder,
    image,
    theme,
    cutout,
    ctaLabel,
    url,
    index,
  } = props;

  useEffect(() => {
    // Trigger the event when
    // the first slide is loaded
    if (index === 0) {
      trackHeroLoad();
    }
  }, [index]);

  return (
    <div className={slide} data-placeholder={placeholder}>
      <div className={contentWrapper} data-cutout={cutout} data-theme={theme}>
        <div className={content} data-theme={theme}>
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
        {ctaLabel && url && (
          <Button
            variant="primary"
            className={buttonSt}
            onClick={() => handleClick(url, index)}
          >
            {ctaLabel}
          </Button>
        )}
      </div>
      <div className={imageSt}>
        {children ? (
          children
        ) : (
          <picture>
            {image?.desktop && (
              <source media="(min-width: 777px)" srcSet={image.desktop.url} />
            )}
            <img
              src={image?.mobile?.url || image?.desktop?.url || ""}
              alt={image?.desktop?.alt || image?.mobile?.alt || title}
              height={
                image?.desktop?.dimensions?.height ||
                image?.mobile?.dimensions?.height
              }
              width={
                image?.desktop?.dimensions?.width ||
                image?.mobile?.dimensions?.width
              }
              loading="lazy"
            />
          </picture>
        )}
      </div>
    </div>
  );
};
